<div id="psychology-lab" class="inner-page py-5">
  <div class="container px-lg-5">

    <!-- Header Section -->
    <div class="text-center mb-5">
      <h1 class="display-6 fw-bold text-uppercase text-orange mb-2" style="color: #f48020;">Psychology Lab</h1>
      <h4 class="fw-semibold text-dark mb-4">"Exploring the Depths of Mind and Behavior"</h4>
      <p class="lead text-muted mx-auto" style="max-width: 900px; line-height: 1.8; text-align: justify;">
        The Psychology Laboratory at Shah Satnam Ji Girls College is a specialized facility that provides students with firsthand exposure to experimental psychology and psychological testing. The lab serves as a hub for cognitive, behavioral, and personality research.
      </p>
      <hr class="divider mx-auto" style="width: 80px; height: 3px; background: #1c5c3e; border: none; opacity: 1;">
    </div>

    <!-- Content Card -->
    <div class="content-card p-4 p-md-5 shadow-sm rounded-4 bg-white border-top border-5 border-success mb-5">
      
      <!-- Lab Apparatus -->
      <h5 class="fw-bold text-success text-uppercase mb-3" style="letter-spacing: 0.5px;">Standardized Psychological Apparatus</h5>
      <p class="text-muted mb-3">Our laboratory is fully equipped with highly accurate classical and modern apparatuses for conducting experiments:</p>
      <ul class="text-muted mb-4" style="line-height: 1.8; padding-left: 20px;">
        <li class="mb-2"><strong>Memory and Learning:</strong> Memory drums, maze learning boards, and bilateral transfer apparatuses to study association and learning speeds.</li>
        <li class="mb-2"><strong>Perception and Attention:</strong> Tachistoscopes, division of attention boards, and Muller-Lyer illusion boards.</li>
        <li class="mb-2"><strong>Reaction Time:</strong> Digital and analog vernier chronoscopes to measure simple and choice reaction times.</li>
        <li class="mb-2"><strong>Sensory Tests:</strong> Color preference apparatus, aesthetic judgement instruments, and weight discrimination sets.</li>
      </ul>

      <!-- Diagnostic Testing -->
      <h5 class="fw-bold text-success text-uppercase mb-3" style="letter-spacing: 0.5px;">Diagnostic & Psychometric Tests</h5>
      <p class="text-muted mb-3">We have an extensive repository of standardized paper-and-pencil psychometric tests:</p>
      <ul class="text-muted mb-4" style="line-height: 1.8; padding-left: 20px;">
        <li class="mb-2"><strong>Intelligence Scales:</strong> Standard Progressive Matrices (SPM), Bhatia's Battery of Performance Tests, and verbal/non-verbal intelligence test sets.</li>
        <li class="mb-2"><strong>Personality Inventories:</strong> Eysenck's Personality Questionnaire, 16 Personality Factor (16PF) questionnaire, and thematic apperception tests.</li>
        <li class="mb-2"><strong>Aptitude and Interest:</strong> Standard occupational interest scales, differential aptitude test batteries, and emotional intelligence metrics.</li>
      </ul>

      <!-- Research and Counselling -->
      <h5 class="fw-bold text-success text-uppercase mb-3" style="letter-spacing: 0.5px;">Research, Counseling, & Mental Wellness</h5>
      <p class="text-muted mb-5" style="text-align: justify; line-height: 1.8;">
        The lab actively supports academic research and serves as a clinical practice center for students learning counseling techniques. It teaches students how to administer, score, and interpret psychological profiles ethically, preparing them for careers in clinical psychology, HR, and educational counseling.
      </p>

      <!-- Psychology Lab Gallery Section -->
      <h5 class="fw-bold text-success text-uppercase mb-3" style="letter-spacing: 0.5px;">Lab Gallery Showcase</h5>
      <div class="row g-3 justify-content-center mb-5">
        <div class="col-6 col-sm-4 col-md-3" *ngFor="let img of psychologyImages">
          <div class="gallery-card rounded-4 overflow-hidden position-relative shadow-sm" (click)="openLightbox(img)">
            <img [src]="img" alt="Psychology Lab Infrastructure" class="img-fluid w-100" style="object-fit: cover; height: 180px; transition: transform 0.3s ease;">
            <div class="gallery-overlay d-flex align-items-center justify-content-center">
              <span class="zoom-icon"><i class="fas fa-search-plus"></i> View Lab</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Alert Banner -->
      <div class="p-4 rounded-4 mt-5 text-center" style="background-color: #fcece3; border: 1px solid #ffd8c3;">
        <h5 class="fw-bold mb-2" style="color: #e06c00;">"The greatest discovery of my generation is that human beings can alter their lives by altering their attitudes of mind."</h5>
        <p class="mb-0 fw-semibold text-muted" style="font-size: 15px;">Equipping students to study the intricacies of human cognition and social behavior.</p>
      </div>

    </div>

    <!-- Fullscreen Backdrop-Blurred Lightbox -->
    <div class="lightbox-backdrop d-flex align-items-center justify-content-center animate-fade-in" *ngIf="activeLightboxImage" (click)="closeLightbox()">
      <div class="lightbox-content position-relative" (click)="$event.stopPropagation()">
        <button class="btn-close-lightbox" (click)="closeLightbox()">&times;</button>
        <img [src]="activeLightboxImage" class="lightbox-img img-fluid rounded-3" alt="Fullscreen Psychology Lab View">
      </div>
    </div>

  </div>
</div>

